var map = {
	"./AUS.svg": [
		"8626",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./Accountability.svg": [
		"2090",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./Asset-Review.svg": [
		"358d",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./BTC.svg": [
		"4b17",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./CHN.svg": [
		"99b1",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./Cash-Flow.svg": [
		"094f",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./Change-LVG.svg": [
		"fe76",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./ETH.svg": [
		"5e5e7",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./EUR.svg": [
		"b8cb",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./IB-icon.svg": [
		"4313",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./IBApplication-icon.svg": [
		"28ae",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./IDN.svg": [
		"72fe8",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./IND.svg": [
		"d129",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./JPN.svg": [
		"ba30",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./MT4.svg": [
		"451f",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./MT5.svg": [
		"69d5c",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./MYS.svg": [
		"ef58",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./Mycommission-icon.svg": [
		"506f",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./PHL.svg": [
		"197d",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./Reset-PWD.svg": [
		"c80a",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./USA.svg": [
		"b0a8",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./USDT.svg": [
		"77de",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./VND.svg": [
		"5184",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./XOH.svg": [
		"a29b",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./account-groups.svg": [
		"0504",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./account-v4.svg": [
		"76de",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./addWallet.svg": [
		"fa0f",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./answer.svg": [
		"af7f",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./answermark.svg": [
		"74a9",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./arrest.svg": [
		"9abd",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./arrow-right.svg": [
		"6929",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./audit-record.svg": [
		"2ed9",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./bankRemit.svg": [
		"9a5c",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./bind.svg": [
		"b572",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./buy.svg": [
		"222b",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./by-pamm.svg": [
		"629c",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./camera.svg": [
		"8ce0",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./card.svg": [
		"2d9e",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./client-account-icon.svg": [
		"ac6c",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./client-rebate-icon.svg": [
		"bc0c",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./client-relations-icon.svg": [
		"7d27",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./clientList-icon.svg": [
		"182e",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./clientMTaccountFundsflow.svg": [
		"d6fe",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./clientRabateList.svg": [
		"4078",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./clock.svg": [
		"4c09",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./close-max.svg": [
		"8da4",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./close-menu.svg": [
		"0dfb",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./close.svg": [
		"7710",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./coffee.svg": [
		"2873",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./collapse-btn.svg": [
		"2d38",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./collapse.svg": [
		"37cc",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./collection.svg": [
		"6c06",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./completed.svg": [
		"2e64",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./contact-us.svg": [
		"1f66",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./coordinate.svg": [
		"f396",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./copy.svg": [
		"19b6",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./correct.svg": [
		"5b4a",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./currentCollection.svg": [
		"2812",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./customerHoldOrder-icon.svg": [
		"34d9",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./customerLimitOrder-icon.svg": [
		"0abc",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./customerTransactionHistory.svg": [
		"e16a",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./customerWalletFlow.svg": [
		"03af",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./danger.svg": [
		"4576",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./dark.svg": [
		"4123",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./dataDown.svg": [
		"9751",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./dataEqual.svg": [
		"56e6",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./dataUp.svg": [
		"0472",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./delete.svg": [
		"59a1",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./deposit-icon.svg": [
		"b13f",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./deposit.svg": [
		"c44e",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./diamond.svg": [
		"7753",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./dropdown-angle.svg": [
		"89c5",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./dropdown.svg": [
		"5586",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./edit.svg": [
		"aa46",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./email.svg": [
		"cbb7",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./emial-vertify.svg": [
		"bfdd",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./error.svg": [
		"b1b9",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./excel.svg": [
		"6599",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./exit.svg": [
		"5dbb",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./expand.svg": [
		"c963",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./eye-close.svg": [
		"efcd",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./eye-open.svg": [
		"d7ec",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./facebook.svg": [
		"40e5",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./fail.svg": [
		"9448",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./filter.svg": [
		"c886",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./flower.svg": [
		"2c4a",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./fortex.svg": [
		"c677",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./frist-deposit.svg": [
		"b705",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./gd.svg": [
		"c86d",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./genCenter-icon.svg": [
		"e674",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./go-custom.svg": [
		"aaae",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./go-modern.svg": [
		"9e79",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./goback.svg": [
		"fd5f",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./google.svg": [
		"6a48",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./grid.svg": [
		"d8ec",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./grzx.svg": [
		"b271",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./history.svg": [
		"c023",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./holdorder.svg": [
		"0f17",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./home.svg": [
		"6bbe",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./icon-crm-earth.svg": [
		"c0c5",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./icon-crm-mail-outlined.svg": [
		"be01",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./in-money.svg": [
		"05b6",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./inBank-icon.svg": [
		"a2b3",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./inCrypto.svg": [
		"887d",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./index-deposit.svg": [
		"b165",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./index-icon.svg": [
		"0fc7",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./index-internal-transfer.svg": [
		"79a8",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./index-kyc.svg": [
		"b0aa",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./index-open-position.svg": [
		"896c",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./index-order-history.svg": [
		"3ef3",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./index-pending-order.svg": [
		"6554",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./index-ta-balance.svg": [
		"e3cf",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./index-ta-flow.svg": [
		"7590",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./index-wallet-flow.svg": [
		"ed7f",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./index-withdrawal.svg": [
		"4d1a",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./info.svg": [
		"4be3",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./interTeleTransfer.svg": [
		"0f62",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./invest.svg": [
		"fe86",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./invitor.svg": [
		"69d9",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./jfsc.svg": [
		"771e",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./jl.svg": [
		"9310",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./jy.svg": [
		"182d4",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./kyc-wrapper.svg": [
		"98f5",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./kyc.svg": [
		"586e",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./level.svg": [
		"ebec",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./light.svg": [
		"7748",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./limit-order.svg": [
		"a767",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./link.svg": [
		"18f0",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./loding.svg": [
		"2b29",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./menu.svg": [
		"bd3d",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./mobile.svg": [
		"30d4",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./money-password.svg": [
		"8968",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./moneyPassword-icon.svg": [
		"7445",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./more-application.svg": [
		"ccca",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./more.svg": [
		"3dd0",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./mtIdJR-icon.svg": [
		"8681",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./my-invest.svg": [
		"aa43",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./my-wallet.svg": [
		"e7ff",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./myInvest-icon.svg": [
		"78f5",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./myinvest.svg": [
		"1919",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./myshare-icon.svg": [
		"554d",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./myshare.svg": [
		"e5fd",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./news-icon.svg": [
		"789d",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./news.svg": [
		"c862",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./no.svg": [
		"31cf",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./notice.svg": [
		"fc99",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./open-account.svg": [
		"e9c3",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./order-no.svg": [
		"684d",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./out-money.svg": [
		"1e8f",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./overview.svg": [
		"c63d",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./pamm-icon.svg": [
		"5152",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./pamm.svg": [
		"43d1",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./pass-security.svg": [
		"f54b",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./payID.svg": [
		"79aa",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./paymentOrder.svg": [
		"fb75",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./pending.svg": [
		"f51c",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./person-center.svg": [
		"6e3e",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./personal-center.svg": [
		"2f37",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./phone-vertify.svg": [
		"d73b",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./phone.svg": [
		"dd82",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./plain-pass.svg": [
		"dee8",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./platform-download.svg": [
		"279a",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./plus-circle.svg": [
		"7938",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./points.svg": [
		"421e",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./pointsMallDeatil-next.svg": [
		"91be",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./pointsMallDeatil-prev.svg": [
		"2a30",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./product-list.svg": [
		"e2f5",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./product-manage.svg": [
		"76cb",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./ptxz.svg": [
		"f670",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./q.svg": [
		"d200",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./qr.svg": [
		"a5e1",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./question.svg": [
		"ae00",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./radio-item-checked.svg": [
		"eabf",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./redirect.svg": [
		"ca8b",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./refused.svg": [
		"679e",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./regist-email.svg": [
		"32ef",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./reload.svg": [
		"217a",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./remove.svg": [
		"861a",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./reset.svg": [
		"9b4b",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./right-outlined.svg": [
		"2fb8",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./search.svg": [
		"8e8d",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./security.svg": [
		"ea43",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./securitysetting.svg": [
		"c08f",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./service.svg": [
		"4e04",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./signal.svg": [
		"8455",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./sirix.svg": [
		"cceb",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./sort-asc.svg": [
		"947c",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./sort-desc.svg": [
		"2552",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./sort.svg": [
		"e528",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./subscribtion.svg": [
		"a6ff",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./success.svg": [
		"a8cf",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./switch.svg": [
		"2384",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./sy.svg": [
		"3ca4",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./tab-center.svg": [
		"4ab5",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./teade-history.svg": [
		"9440",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./telegram.svg": [
		"9a40",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./tg.svg": [
		"77ec",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./theme.svg": [
		"e534",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./thirdparty-loading.svg": [
		"24d9",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./thirdparty.svg": [
		"4246",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./ticket-icon.svg": [
		"b29c",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./to-top.svg": [
		"8f9d",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./trade-account-create.svg": [
		"c723",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./trade-account-more.svg": [
		"17e10",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./trade-account.svg": [
		"6077",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./trade-filter.svg": [
		"9484",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./trade-history.svg": [
		"e9b2",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./tradeaccount.svg": [
		"e643",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./turn-off.svg": [
		"7ae1",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./turn-on.svg": [
		"d406",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./twiter.svg": [
		"af7d",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./upgrade.svg": [
		"b33e",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./wallet-v4.svg": [
		"7c3f",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./wallet-water.svg": [
		"43ee",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./wallet.svg": [
		"402b",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./warning.svg": [
		"7e6f",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./with-draw-icon.svg": [
		"6bcf",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./with-draw.svg": [
		"d876",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./xmam.svg": [
		"e84e",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./xxtz.svg": [
		"b3a5",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./yes.svg": [
		"8d65",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	],
	"./zjgl.svg": [
		"6b2a",
		"chunk-svg-icons",
		"vendors~svg-AUS-svg~svg-Accountability-svg~svg-Asset-Review-svg~svg-BTC-svg~svg-CHN-svg~svg-Cash-Flo~972d4e3c"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f943";
module.exports = webpackAsyncContext;